import { render, staticRenderFns } from "./zhifu.vue?vue&type=template&id=0a734e6d&scoped=true"
import script from "./zhifu.vue?vue&type=script&lang=js"
export * from "./zhifu.vue?vue&type=script&lang=js"
import style0 from "./zhifu.vue?vue&type=style&index=0&id=0a734e6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a734e6d",
  null
  
)

export default component.exports